const copy = {
  intro: {
    title: 'Customer Service Savings Calculator',
    headline: 'Time to talk about reducing customer service costs',
    contentTitle: 'Want to drive customer satisfaction in the moment?',
    content: 'Calculate how much you can save by making your current chatbots, knowledge bases, and contact center platforms more intelligent, fluent, and helpful so that your support agents can deflect easier cases and drive customer loyalty.',
    formTitle: 'Calculate Your Savings',
  },
  questionpages: {
    resultbutton: 'Get Your Results',
    nextbutton: 'Next',
    previousbutton: 'Previous'
  },
  questions: [
    {
      question: 'Enter how many calls you think your contact center receives per month.',
      type: 'number',
      instructions: 'Enter number of calls',
      statTitle: '66%',
      stat: 'Contact center decision makers agree digital will significantly increase call volume in the next \n' +
        '2 years.',
    },
    {
      question: 'Enter in minutes what you think your average call time is.',
      type: 'number',
      instructions: 'Enter number of minutes',
      statTitle: '66%',
      stat: 'of customers still resolve issues with a company via telephone.',
    }, 
    {
      question: 'Enter in US dollars how much you think each call costs your support organization.',
      type: 'dollars',
      instructions: 'In US dollars',
      statTitle: '23%',
      stat: 'One organization saw a 23% reduction in customer service expenses by adopting and investing in self-service.',
    }, 
    {
      question: 'If your agents had better access to information, how much time do you think you could save?',
      type: 'slider',
      instructions: 'Use the slider',
      statTitle: '50%',
      stat: 'A major insurance company reduced the time to answer customer questions by 50% with Lucidworks.',
    }, 
    {
      question: 'If customers had better self-service options to help with call deflection, by how much do you think you could reduce call volume to your agents?',
      type: 'slider',
      instructions: 'Use the slider',
      statTitle: '7%',
      stat: 'Lucidworks helped Red Hat decrease support ticket volume by 7%.',
    }, 
  ],
  results: {
    title: 'Smart Answers Savings Calculator ',
    headlineHTML: 'Potential yearly <br />cost savings:',
    contentHTML: '<p>Attrition rates in contact centers are twice the average for other job functions. Freeing agents so they can take their time to address the complex customer support questions will lead to better service, better employee retention and increased customer satisfaction.</p> <p>Ready to cut customer service costs? <a href="#">Schedule a consultation today</a> to see how you can  change the conversation with Lucidworks. <a href="#">Watch our service solution video</a> to learn more.</p>',
    cta: "CONTACT US",
    startover: "START OVER",
    watchvideoHTML: '<a href="https://lucidworks.com/videos/lucidworks-connected-experience-cloud/">WATCH VIDEO</a>',
  }
}


export default copy;
